export const ductSystemSteps = [
  {
    title: "Spiral Duct & Fittings",
    defaultSpecSection: "233113-2.4",
    defaultSectionTitle: "Spiral Pipe",
    fields: [
      {
        name: "spiral_duct_prod_id",
        label: "Spiral Duct",
        type: "dropdown",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
          { label: "option 3", value: "option 3" },
        ],
      },
      {
        name: "spiral_ftg_prod_id",
        label: "Spiral Fittings",
        type: "dropdown",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
          { label: "option 3", value: "option 3" },
        ],
      },
      {
        name: "spiral_heto_prod_id",
        label: "Hetos",
        type: "dropdown",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
          { label: "option 3", value: "option 3" },
        ],
      },
    ],
  },
  {
    title: "Duct Liner",
    defaultSpecSection: "233113-2.5",
    defaultSectionTitle: "Duct Liner",
  },
  {
    title: "Sealants",
    defaultSpecSection: "233113-2.6",
    defaultSectionTitle: "Sealants",
  },
  {
    title: "Hangers and Supports",
    defaultSpecSection: "233113-2.7",
    defaultSectionTitle: "Hangers and Supports",
    fields: [
      {
        name: "hanger_susp_prod_id",
        label: "Hanger Suspension System",
        type: "dropdown",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
        ],
      },
      {
        name: "hanger_inserts_prod_id",
        label: "Hanger Inserts (Select All That Apply)",
        type: "checkbox",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
          { label: "option 3", value: "option 3" },
          { label: "option 4", value: "option 4" },
          { label: "option 5", value: "option 5" },
        ],
      },
    ],
  },
  {
    title: "Turning Vanes",
    defaultSpecSection: "233300-2.7",
    defaultSectionTitle: "Turning Vanes",
  },
  {
    title: "Access Doors",
    defaultSpecSection: "233300-2.8",
    defaultSectionTitle: "Duct Mounting Access Doors",
  },
  {
    title: "Flexible Connectors",
    defaultSpecSection: "233300-2.10",
    defaultSectionTitle: "Flexible Connectors",
    fields: [
      {
        name: "flex_conn_prod_id",
        label: "Flexible Connectors Material",
        type: "dropdown",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
          { label: "option 3", value: "option 3" },
          { label: "option 4", value: "option 4" },
          { label: "option 5", value: "option 5" },
          { label: "option 6", value: "option 6" },
        ],
      },
    ],
  },
  {
    title: "Flexible Ducts",
    defaultSpecSection: "233300-2.11",
    defaultSectionTitle: "Flexible Ducts",
    fields: [
      {
        name: "flex_duct_type_id",
        label: "Flexible Duct Type",
        type: "dropdown",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
          { label: "option 3", value: "option 3" },
          { label: "option 4", value: "option 4" },
          { label: "option 5", value: "option 5" },
          { label: "option 6", value: "option 6" },
        ],
      },
      {
        name: "flex_duct_insulation_prod_id",
        label: "Flexible Duct Insulation",
        type: "dropdown",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
          { label: "option 3", value: "option 3" },
        ],
      },
      {
        name: "flex_duct_clamp_prod_id",
        label: "Flexible Duct Ties",
        type: "dropdown",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
        ],
      },
    ],
  },

  {
    title: "Duct Cleaning Protocol",
    defaultSpecSection: "233300-2.15",
    defaultSectionTitle: "Ductwork Cleaning Protocal",
    fields: [
      {
        name: "duct_clean_prod_id",
        label: "Duct Cleaning Protocol",
        type: "dropdown",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
          { label: "option 3", value: "option 3" },
        ],
      },
    ],
  },
  {
    title: "Leak Testing Protocol",
    defaultSpecSection: "233300-2.30",
    defaultSectionTitle: "Ductwork Leakage Testing Protocal",
    fields: [
      {
        name: "leak_test_prod_id",
        label: "Leak Testing Protocol",
        type: "dropdown",
        options: [
          { label: "option 1", value: "option 1" },
          { label: "option 2", value: "option 2" },
          { label: "option 3", value: "option 3" },
        ],
      },
    ],
  },
];

// You can create different step configurations for different processes
export const specificationSteps = [
  {
    title: "Specification Type",
    fields: [
      {
        name: "specType",
        label: "Specification Type",
        type: "dropdown",
        options: [
          { label: "Performance Specification", value: "performance" },
          { label: "Material Specification", value: "material" },
          { label: "Installation Specification", value: "installation" },
        ],
      },
    ],
  },
];
